<footer class="footer">
  <div class="footer-container">

    <!-- ABOUT -->
    <div class="footer-col">
      <h3>ABOUT</h3>
      <a routerLink="/about"><mat-icon>info</mat-icon> About Us</a>
      <a routerLink="/blog"><mat-icon>article</mat-icon> Blog</a>
      <a routerLink="/faq"><mat-icon>help</mat-icon> FAQ</a>
      <a routerLink="/contact"><mat-icon>contacts</mat-icon> Contact Us</a>
    </div>

    <!-- HELP -->
    <div class="footer-col">
      <h3>HELP</h3>
      <a routerLink="/home"><mat-icon>shopping_cart</mat-icon> Home</a>
      <a routerLink="/authentication/login"><mat-icon>login</mat-icon> Sign In</a>
      <a routerLink="/authentication/register"><mat-icon>person_add</mat-icon> Sign Up</a>
      <a routerLink="/contact"><mat-icon>report_problem</mat-icon> Report Issue</a>
    </div>

    <!-- POLICY -->
    <div class="footer-col">
      <h3>POLICY</h3>
      <a routerLink="/return-policy"><mat-icon>assignment_return</mat-icon> Return Policy</a>
      <a routerLink="/terms-of-use"><mat-icon>gavel</mat-icon> Terms of Use</a>
      <a routerLink="/privacy"><mat-icon>privacy_tip</mat-icon> Privacy</a>
      <a routerLink="/security"><mat-icon>security</mat-icon> Security</a>
    </div>

    <!-- SOCIAL -->
    <div class="footer-col">
      <h3>SOCIAL</h3>
      <div class="social-icons">
        <a href="https://facebook.com" target="_blank"><mat-icon>facebook</mat-icon>Facebook</a>
        <a href="https://x.com" target="_blank"><mat-icon>share</mat-icon>X</a>
        <a href="https://linkedin.com" target="_blank"><mat-icon>linkedin</mat-icon>Linkedin</a>
        <a href="https://instagram.com" target="_blank"><mat-icon>photo_camera</mat-icon>Instagram</a>
      </div>
    </div>

    <!-- HELP CENTER -->
    <div class="footer-col">
      <h3>HELP CENTER</h3>
      <div class="help-row">
        <mat-icon>email</mat-icon>
        <a href="mailto:support@touchpointstechnology.com">support@abc.com</a>
      </div>
      <div class="help-row">
        <mat-icon>phone</mat-icon>
        <a href="tel:+919876543210">+91 98765 43210</a>
      </div>
      <div class="help-row">
        <mat-icon>location_on</mat-icon>
        <span>Main Street, Frisco, TX 75033, USA</span>
      </div>
    </div>


  </div>

  <!-- Bottom -->
  <div class="footer-bottom">
    <p>&copy; {{ currentYear }} Design & Developed by
      <a href="https://www.flowdrizzle.com/" target="_blank">FlowDrizzle Team</a>
    </p>
  </div>
</footer>